import Action  from './baseActions';
import {IBlock} from '../../models';

// Types

export enum SavedBlockActionTypes {
  LOAD_SAVED_BLOCKS = 'savedBlock/load_saved_blocks',
  LOADING_SAVED_BLOCKS = 'savedBlock/loading_saved_blocks',
  LOADED_SAVED_BLOCKS = 'savedBlock/loaded_saved_blocks',
  LOADING_SAVED_BLOCKS_FAILED = 'savedBlock/loading_saved_blocks_failed',

  CREATE_SAVED_BLOCK = 'savedBlock/create_saved_block',
  CREATING_SAVED_BLOCK = 'savedBlock/creating_saved_block',
  CREATED_SAVED_BLOCK = 'savedBlock/created_saved_block',
  CREATING_SAVED_BLOCK_FAILED = 'savedBlock/creating_saved_block_failed',

  DELETE_SAVED_BLOCK = 'savedBlock/delete_saved_block',
  DELETING_SAVED_BLOCK = 'savedBlock/deleting_saved_block',
  DELETED_SAVED_BLOCK = 'savedBlock/deleted_saved_block',
  DELETING_SAVED_BLOCK_FAILED = 'savedBlock/deleting_saved_block_failed',
}

// Interfaces

export interface LoadSavedBlockAction extends Action {
  type: SavedBlockActionTypes.LOAD_SAVED_BLOCKS;
  payload?: any;
}

export interface LoadingSavedBlocksAction extends Action {
  type: SavedBlockActionTypes.LOADING_SAVED_BLOCKS;
}

export interface LoadedSavedBlocksAction extends Action {
  type: SavedBlockActionTypes.LOADED_SAVED_BLOCKS;
  payload: any;
}

export interface LoadingSavedBlocksFailedAction extends Action {
  type: SavedBlockActionTypes.LOADING_SAVED_BLOCKS_FAILED;
}

export interface CreateSavedBlockAction extends Action {
  type: SavedBlockActionTypes.CREATE_SAVED_BLOCK;
  payload: Partial<IBlock>;
}

export interface CreatingSavedBlockAction extends Action {
  type: SavedBlockActionTypes.CREATING_SAVED_BLOCK;
}

export interface CreatedSavedBlockAction extends Action {
  type: SavedBlockActionTypes.CREATED_SAVED_BLOCK;
  payload: any;
}

export interface CreatingSavedBlockFailedAction extends Action {
  type: SavedBlockActionTypes.CREATING_SAVED_BLOCK_FAILED;
}

export interface DeleteSavedBlockAction extends Action {
  type: SavedBlockActionTypes.DELETE_SAVED_BLOCK;
  payload: string;
}

export interface DeletingSavedBlockAction extends Action {
  type: SavedBlockActionTypes.DELETING_SAVED_BLOCK;
}

export interface DeletedSavedBlockAction extends Action {
  type: SavedBlockActionTypes.DELETED_SAVED_BLOCK;
  payload: string;
}

export interface DeletingSavedBlockFailedAction extends Action {
  type: SavedBlockActionTypes.DELETING_SAVED_BLOCK_FAILED;
}

// Functions

export function loadSavedBlocks(): LoadSavedBlockAction {
  return {
    type: SavedBlockActionTypes.LOAD_SAVED_BLOCKS,
  };
}

export function loadingSavedBlocks(): LoadingSavedBlocksAction {
  return {
    type: SavedBlockActionTypes.LOADING_SAVED_BLOCKS,
  };
}

export function loadedSavedBlocks(result: any): LoadedSavedBlocksAction {
  return {
    type: SavedBlockActionTypes.LOADED_SAVED_BLOCKS,
    payload: {
      result,
    },
  };
}

export function loadingSavedBlocksFailed(): LoadingSavedBlocksFailedAction {
  return {
    type: SavedBlockActionTypes.LOADING_SAVED_BLOCKS_FAILED,
  }
}

export function createSavedBlock(savedBlock: Partial<IBlock>): CreateSavedBlockAction {
  return {
    type: SavedBlockActionTypes.CREATE_SAVED_BLOCK,
    payload: savedBlock,
  };
}

export function creatingSavedBlock(): CreatingSavedBlockAction {
  return {
    type: SavedBlockActionTypes.CREATING_SAVED_BLOCK,
  };
}

export function createdSavedBlock(savedBlock: any): CreatedSavedBlockAction {
  return {
    type: SavedBlockActionTypes.CREATED_SAVED_BLOCK,
    payload: savedBlock,
  };
}

export function creatingSavedBlockFailed(): CreatingSavedBlockFailedAction {
  return {
    type: SavedBlockActionTypes.CREATING_SAVED_BLOCK_FAILED,
  };
}

export function deleteSavedBlock(uid: string): DeleteSavedBlockAction {
  return {
    type: SavedBlockActionTypes.DELETE_SAVED_BLOCK,
    payload: uid,
  };
}

export function deletingSavedBlock(): DeletingSavedBlockAction {
  return {
    type: SavedBlockActionTypes.DELETING_SAVED_BLOCK,
  };
}

export function deletedSavedBlock(uid: string): DeletedSavedBlockAction {
  return {
    type: SavedBlockActionTypes.DELETED_SAVED_BLOCK,
    payload: uid,
  };
}

export function deletingSavedBlockFailed(): DeletingSavedBlockFailedAction {
  return {
    type: SavedBlockActionTypes.DELETING_SAVED_BLOCK_FAILED,
  };
}

export type SavedBlockAction =
  LoadSavedBlockAction |
  LoadingSavedBlocksAction |
  LoadedSavedBlocksAction |
  LoadingSavedBlocksFailedAction |
  CreateSavedBlockAction |
  CreatingSavedBlockAction |
  CreatedSavedBlockAction |
  CreatingSavedBlockFailedAction |
  DeleteSavedBlockAction |
  DeletingSavedBlockAction |
  DeletedSavedBlockAction |
  DeletingSavedBlockFailedAction;
